import { Box, Button, Flex, Text } from '@tonic-one/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DataTrack from '@Components/DataTrack';
import StepIndicator from '../../UpdateToVisionOne/components/StepIndicator';

const EnableEmailAndCollaboration = ({
  isFoundation,
  provisionNewCas,
}: {
  isFoundation: boolean;
  provisionNewCas: () => void;
}) => {
  const { t } = useTranslation();
  const [current, setCurrent] = useState<number>(0);

  useEffect(() => {
    setCurrent(isFoundation ? 1 : 0);
  }, [isFoundation]);

  return (
    <Box
      backgroundColor="#212121"
      borderRadius="8px"
      p="32px 90px"
      width="866px"
    >
      <Text fontSize="18px" lineHeight="24px" color="#FFFFFF" mb="24px">
        {t('welcome.updateVisionSolution.getStarted.action.title')}
      </Text>

      {/* Step 1: Update TrendAI Vision One */}
      <Flex>
        <StepIndicator
          stepNumber={1}
          isActive={current === 0}
          isCompleted={current > 0}
          showConnector
        />
        <Box flex={1} pb="32px">
          <Text
            fontSize="16px"
            color={current === 0 ? '#FFFFFF' : '#8C8C8C'}
            mb="8px"
          >
            {t('welcome.updateVisionSolution.getStarted.step1.title')}
          </Text>
          {current === 0 ? (
            <Box>
              <Text color="#8C8C8C" mb="20px" fontSize="14px">
                {t('welcome.updateVisionSolution.getStarted.step1.desc')}
              </Text>
              <DataTrack type="GetStartedToVisionOne.Step1.Click">
                <Button
                  variant="secondary"
                  onClick={() => {
                    (window.parent as any).APP.$eventBus.$emit(
                      'toggleUICEvent',
                      'showFoundationUpdate',
                      { modalShow: true }
                    );
                  }}
                >
                  <Text fontSize="14px">
                    {t(
                      'welcome.updateVisionSolution.getStarted.step1.button.label'
                    )}
                  </Text>
                </Button>
              </DataTrack>
            </Box>
          ) : (
            <Text fontSize="14px" color="#8C8C8C">
              {t('welcome.updateVisionSolution.action.step2.done')}
            </Text>
          )}
        </Box>
      </Flex>

      {/* Step 2: Provision Cloud Email and Collaboration Protection */}
      <Flex>
        <StepIndicator
          stepNumber={2}
          isActive={current === 1}
          isCompleted={false}
        />
        <Box flex={1}>
          <Text
            fontSize="16px"
            color={current === 1 ? '#FFFFFF' : '#8C8C8C'}
            mb="8px"
          >
            {t('welcome.updateVisionSolution.getStarted.step2.title')}
          </Text>
          <Text color="#8C8C8C" mb="20px" fontSize="14px">
            {t('welcome.updateVisionSolution.getStarted.step2.desc')}
          </Text>
          <Button
            variant="secondary"
            disabled={current !== 1}
            onClick={provisionNewCas}
          >
            <Text fontSize="14px">
              {t('welcome.updateVisionSolution.getStarted.step2.button.label')}
            </Text>
          </Button>
        </Box>
      </Flex>
    </Box>
  );
};

export default EnableEmailAndCollaboration;
